import { Component, OnInit } from '@angular/core';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { TranslateService } from '@ngx-translate/core';

import { TabBarLinkInterface } from '~/component/router-tab-bar/interfaces/tab-link.interface';
import { TitleService } from '~/core/services/title/title.service';

@Component({
  selector: 'app-attendee-bookings',
  templateUrl: './bookings.component.html',
})
export class AttendeeBookingsComponent implements OnInit {
  public readonly tabBarlinks: TabBarLinkInterface[] = [];

  constructor(
    private readonly translateService: TranslateService,
    private readonly localizeRouterService: LocalizeRouterService,
    private readonly titleService: TitleService
  ) {}

  public ngOnInit(): void {
    this.titleService.setPageTitle('seo.attendee.bookings.title');

    this.tabBarlinks.push(
      ...['waiting', 'upcoming', 'past', 'canceled'].map((status) => ({
        name: this.translateService.instant(
          `attendee.bookings.tab_bar.link.${status}`
        ),
        path: this.localizeRouterService
          .translateRoute(`attendee.${status}`)
          .toString(),
      }))
    );
  }
}
